export const environment = {
  production: false,
  baseUrl: 'https://api2-dev.payee.tech/payment',

  HELP_URL: 'https://help.payee.tech/hu/',
};
